import React, { useEffect, useState } from "react";
import { FaCheck, FaClock, FaExclamationTriangle, FaTimes } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Badge, Card, Col, Form, Row, Table } from "react-bootstrap";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import ReviewStudyUnblindRequestManagement from "./ReviewStudyUnblindRequestManagement";
import AddNewStudyUnblindRequestManagement from "./AddNewStudyUnblindRequestManagement";
import StudyUnblindRequestManagementActivities from "./StudyUnblindRequestManagementActivities";
import { eiwrsUnblindingRequestManagementServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingRequestManagementServices";
import RevokeStudyUnblindRequestManagement from "./RevokeStudyUnblindRequestManagement";
import ViewStudyRequestManagementDetail from "./ViewStudyRequestManagementDetail";
import Moment from "react-moment";

const StudyUnblindRequestManagementDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [requestData, setRequestData] = useState("");
  const [statsRequestData, setStatsRequestData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [requestList, setRequestList] = useState([]);
  const [unblindRequestManagementCount, setUnblindRequestManagementCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [requestId, setRequestId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [unblindRequestManagementActivity, setUnblindRequestManagementActivity] = useState([]);
  const [unblindRequestManagementActivityCount, setUnblindRequestManagementActivityCount] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(unblindRequestManagementCount / itemsPerPage);

  const getEIWRSUnblindingRequestData = async (e) => {
    setLoading(true);
    let data = await eiwrsUnblindingRequestManagementServices.getEIWRSUnblindingRequestData(
      studyId,
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setRequestList(data?.data || []);
    setUnblindRequestManagementCount(data?.count || 0);
    setLoading(false);
  };

  const getEIWRSUnblindingRequestStats = async (e) => {
    let data = await eiwrsUnblindingRequestManagementServices.getEIWRSUnblindingRequestStats(
      studyId,
      StudyMode,
    );
    setStatsRequestData(data?.data || "");
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSUnblindingRequest",
      studyId,
      requestData?.requestId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setUnblindRequestManagementActivity(data?.data || []);
    setUnblindRequestManagementActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [requestData]);

  useEffect(() => {
    getEIWRSUnblindingRequestData();
  }, [searchData, pageNumber, itemsPerPage]);

  useEffect(() => {
    getEIWRSUnblindingRequestStats();
  }, []);

  const StatusBadge = ({ status }) => {
    let className = "bg-secondary";
    let dotColor = "#6c757d";

    if (status === "pending") {
      className = "bg-warning text-dark";
      dotColor = "#ffc107";
    } else if (status === "approved") {
      className = "bg-success";
      dotColor = "#198754";
    } else if (status === "rejected") {
      className = "bg-danger";
      dotColor = "#dc3545";
    } else if (status === "cancelled") {
      className = "bg-secondary";
      dotColor = "#6c757d";
    } else if (status === "expired") {
      className = "bg-danger";
      dotColor = "#dc3545";
    } else if (status === "revoked") {
      className = "bg-danger";
      dotColor = "#dc3545";
    }

    return (
      <Badge
        className={`${className} text-capitalize hstack gap-1`}
        style={{ width: "fit-content" }}
      >
        <span
          className="d-inline-block rounded-circle"
          style={{ backgroundColor: dotColor }}
        ></span>
        {status}
      </Badge>
    );
  };

  const overviewCards = [
    {
      title: "Total",
      value: statsRequestData?.total,
      subtitle: "Total requests received in the study",
      icon: <FaCheck className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Pending",
      value: statsRequestData?.pending,
      subtitle: "Requests awaiting review and decision",
      icon: <FaClock className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Approved",
      value: statsRequestData?.approved,
      subtitle: "Requests successfully approved",
      icon: <FaCheck className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Rejected",
      value: statsRequestData?.rejected,
      subtitle: "Requests declined after review",
      icon: <FaTimes className="bg-white text-danger shadow-sm" />,
    },
    {
      title: "Cancelled",
      value: statsRequestData?.cancelled,
      subtitle: "Requests cancelled before completion",
      icon: <FaXmark className="bg-white text-danger shadow-sm" />,
    },
    {
      title: "Emergency",
      value: statsRequestData?.emergency,
      subtitle: "Requests requiring urgent attention",
      icon: (
        <FaExclamationTriangle className="bg-white text-danger shadow-sm" />
      ),
    },
    {
      title: "Revoked",
      value: statsRequestData?.revoked,
      subtitle: "Previously approved requests revoked",
      icon: (
        <FaExclamationTriangle className="bg-white text-warning shadow-sm" />
      ),
    },
  ];

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {(StudyMode === "DBP Mode" || eiwrsPermission?.liveManageUnblindingRequest || eiwrsPermission?.qcManageUnblindingRequest) &&
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add New"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setRequestId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
                  }`}
              />
              <div className="vr"></div>
            </>
          }
          {unblindRequestManagementCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={requestId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyUnblindRequestManagement getEIWRSUnblindingRequestStats={getEIWRSUnblindingRequestStats} getEIWRSUnblindingRequestData={getEIWRSUnblindingRequestData} />
          )}
          <>
            <div className="p-2 border-bottom" style={{ backgroundColor: "#f8f9fa" }}>
              <Row className="g-2 py-2">
                {overviewCards?.map((item, index) => (
                  <Col xl={3} lg={4} md={6} sm={12} key={index}>
                    <Card className="app-card bg-light border h-100">
                      <Card.Body>
                        <div className="d-flex gap-3">
                          <div className="study_icopn">
                            {item.icon}
                          </div>

                          <div>
                            <Card.Title style={{ fontSize: 16 }}>
                              {item.title}
                            </Card.Title>

                            <Card.Text className="m-0">
                              {item.value || "0"}
                            </Card.Text>

                            <Card.Text style={{ fontSize: 11 }}>
                              {item.subtitle}
                            </Card.Text>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
            {loading ? (
              <PageLoader />
            ) : unblindRequestManagementCount === 0 ? (
              <NoDataFoundTable MSG={"Study Unblind Request not found!"} />
            ) : requestList?.length === 0 ? (
              <NoDataFoundTable MSG={"Search Study Unblind Request not found!"} />
            ) : (
              <>
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 1)}>
                        RequestId
                      </th>
                      <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 2)}>
                        Site
                      </th>
                      <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 3)}>
                        Subject
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>
                        Request Type
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 5)}>
                        Urgency
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 6)}>
                        Access Duration
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 7)}>
                        Requested By
                      </th>
                      <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 8)}>
                        Status
                      </th>
                      <th style={{ width: 120 }} onMouseDown={(e) => onMouseDown(e, 9)}>
                        Requested DT
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 10)}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestList?.map((requestData, index) => (
                      <tr
                        key={index}
                        title="View Details CP"
                        className={`${requestId === requestData?._id ? "highlighted" : ""
                          }`}
                        onClick={() => setIsFormOpen(false)}
                      >
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                          className="text-center"
                        >
                          {index + 1 + startIndex}.
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          {requestData?.requestNumber}
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          {requestData?.siteName}
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          {requestData?.subjectName}
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          {requestData?.requestType}
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          {requestData?.urgency === "emergency" ?
                            <Badge
                              className="bg-danger d-flex align-items-center gap-1"
                              style={{ width: "fit-content" }}
                            >
                              <FaExclamationTriangle size={10} />
                              Emergency
                            </Badge>
                            : requestData?.urgency === "urgent" ?
                              <Badge
                                className="bg-warning text-dark d-flex align-items-center gap-1"
                                style={{ width: "fit-content" }}
                              >
                                Urgent
                              </Badge>
                              :
                              <Badge
                                className="bg-secondary d-flex align-items-center gap-1"
                                style={{ width: "fit-content" }}
                              >
                                Routine
                              </Badge>
                          }
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          {requestData?.accessDuration || "_"}
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          {requestData?.requestByName}
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          <StatusBadge status={requestData.status} />
                        </td>
                        <td
                          onClick={() => {
                            setRequestData(requestData);
                            setRequestId(requestData?._id);
                          }}
                        >
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {requestData?.createdAt}
                          </Moment>
                        </td>
                        <td>
                          <button
                            onClick={(e) => {
                              setRequestData(requestData);
                              setToggle2();
                              e.stopPropagation();
                            }}
                            className="updateProfile mx-2"
                            style={{ padding: "1px 10px" }}
                          >
                            View
                          </button>
                          {(StudyMode === "DBP Mode" || eiwrsPermission?.liveManageUnblindingRequest || eiwrsPermission?.qcManageUnblindingRequest) &&
                            <>
                              {requestData.status === "approved" &&
                                <button
                                  onClick={(e) => {
                                    setRequestData(requestData);
                                    setToggle1();
                                    e.stopPropagation();
                                  }}
                                  className="removeProfile mx-2"
                                  style={{ padding: "1px 10px" }}
                                >
                                  Revoke
                                </button>
                              }
                              {(requestData?.review && requestData.status === "pending") &&
                                <button
                                  onClick={(e) => {
                                    setRequestData(requestData);
                                    setToggle();
                                    e.stopPropagation();
                                  }}
                                  className="updateProfile mx-2"
                                  style={{ padding: "1px 10px" }}
                                >
                                  Review
                                </button>
                              }
                            </>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={unblindRequestManagementCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </>
        </SplitPane>
        {requestId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setRequestId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyUnblindRequestManagementActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                unblindRequestManagementActivity={unblindRequestManagementActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                requestData={requestData}
                unblindRequestManagementActivityCount={unblindRequestManagementActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <ViewStudyRequestManagementDetail
        Show={!toggle2}
        Hide={setToggle2}
        requestData={requestData}
        Title={"View Request Details"}
      />
      <ReviewStudyUnblindRequestManagement
        Show={!toggle}
        Hide={setToggle}
        requestData={requestData}
        setRequestId={setRequestId}
        getEIWRSUnblindingRequestStats={getEIWRSUnblindingRequestStats}
        getEIWRSUnblindingRequestData={getEIWRSUnblindingRequestData}
        Title={"Review now"}
      />
      <RevokeStudyUnblindRequestManagement
        Show={!toggle1}
        Hide={setToggle1}
        requestData={requestData}
        setRequestId={setRequestId}
        getEIWRSUnblindingRequestStats={getEIWRSUnblindingRequestStats}
        getEIWRSUnblindingRequestData={getEIWRSUnblindingRequestData}
        Title={"Revoke now"}
      />
    </>
  );
};

export default StudyUnblindRequestManagementDataList;
